import {useAppDispatch, useAppSelector} from '@buncha/config/redux/hooks';
import {useCallback, useEffect, useState} from 'react';

import {BackHandler} from 'react-native';
import {GET_CONSTANTS} from '@buncha/config/graphQL/documentNode/queries';
import {getScanditKey as getScanditData} from '@buncha/utils/appInfo';
import {gqlService} from '@buncha/config/graphQL';
import {onBoardingActions} from '@buncha/onBoarding/reducer';

export function useGetConstantsForApp() {
  const dispatch = useAppDispatch();
  const [constantLoading, setConstatLoading] = useState(false);
  const constants = useAppSelector(gState => gState?.onboarding?.constants);

  const getConstantsForApp = async () => {
    if (constants) return constants;
    try {
      setConstatLoading(true);
      const response = await gqlService?.query({
        query: GET_CONSTANTS,
        fetchPolicy: 'cache-first',
      });
      const constantData = response?.data?.getConstants;
      if (dispatch && constantData)
        dispatch(onBoardingActions.setConstants(constantData));
      setConstatLoading(false);
      return constantData;
    } catch (err: any) {
      setConstatLoading(false);
    }
  };
  return {getConstantsForApp, constantLoading};
}

export function useDisableBack() {
  useEffect(() => {
    const backAction = () => {
      return true;
    };
    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      backAction,
    );
    return () => backHandler.remove(); // Cleanup listener on unmount
  }, []);
}

export function useScanditKey() {
  const userId = useAppSelector(gState => gState.onboarding.currentUser?.id);
  const DEVELOPER_IDS = useAppSelector(
    gState => gState.onboarding.constants?.DEVELOPER_IDS,
  );

  const getScanditKey = useCallback(() => {
    if (userId && DEVELOPER_IDS) {
      const developerIds = JSON.parse(DEVELOPER_IDS ?? '[]');
      return getScanditData(developerIds.includes(userId));
    }
    return '';
  }, [DEVELOPER_IDS, userId]);

  return {getScanditKey};
}

export const checkImageExists = async (url: string): Promise<boolean> => {
  try {
    const response = await fetch(url, {
      method: 'HEAD',
    });

    return (
      response.ok &&
      Boolean(response.headers.get('Content-Type')?.startsWith('image/'))
    );
  } catch (err) {
    return false;
  }
};
